import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block h-[100%] bg-[#fff] bg-slate-100" }
const _hoisted_2 = { class: "header-container" }
const _hoisted_3 = { class: "header-actions" }
const _hoisted_4 = { class: "user-info-btn" }
const _hoisted_5 = { class: "user-name" }
const _hoisted_6 = { class: "flex justify-center pt-[80px] px-4" }
const _hoisted_7 = { class: "w-full max-w-[900px]" }
const _hoisted_8 = { class: "block bg-[#fff] p-[20px] lg:p-[40px] shadow-lg main-content" }
const _hoisted_9 = { class: "lg:hidden mb-6" }
const _hoisted_10 = { class: "flex items-center justify-between mb-4" }
const _hoisted_11 = { class: "text-sm text-gray-600" }
const _hoisted_12 = { class: "text-sm font-medium" }
const _hoisted_13 = { class: "w-full bg-gray-200 rounded-full h-2" }
const _hoisted_14 = { class: "hidden lg:block" }
const _hoisted_15 = { class: "mb-[20px] block text-center mt-[20px] lg:mt-[40px] mb-[20px] lg:mb-[40px] text-sm lg:text-base px-2" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = {
  key: 0,
  class: "button-container"
}
const _hoisted_21 = { class: "flex flex-col md:flex-row justify-end gap-3 button-wrapper" }
const _hoisted_22 = {
  key: 1,
  class: "button-container"
}
const _hoisted_23 = { class: "flex flex-col md:flex-row justify-center gap-3 button-wrapper" }

import FirstStep from './firstStep.vue'
import ThreeStep from './threeStep.vue'
import FourStep from './fourStep.vue'
import FiveStep from './fiveStep.vue'
import ConfirmOrder from '@/components/ConfirmOrder.vue'
import OrderQuery from '@/components/OrderQuery.vue'
import LoginModal from '@/components/LoginModal.vue'
import OrderHistory from '@/components/OrderHistory.vue'
import { ref, watch, onMounted } from 'vue'
import { reactive } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { User, ArrowDown, Document, SwitchButton } from '@element-plus/icons-vue'
import { useRouter } from 'vue-router'
import { getUser, logout } from '@/api/api'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const router = useRouter()
const active = ref(0)
const confirmDialogVisible = ref(false)
const orderQueryVisible = ref(false)
const loginDialogVisible = ref(false)
const orderHistoryVisible = ref(false)
const isLoggedIn = ref(false)
const userDisplayName = ref('')
const orderQueryOrderNumber = ref('')
const isBackNavigation = ref(false)
const stepLoading = ref(false) // 步骤加载状态
const validationState = reactive({
  name: true,
  region: true,
  keywords: true,
});
const orderData = reactive({
  title: '',
  wordNumber: 0,
  orderNumber: '',
  content: '',
  keywords: [] as string[],
  literature: [] as any[],
  abstract: '',
  catalogs: [] as any[]
})
  
  const form = reactive({
    name: '', // 标题字段，直接在第一步输入
    region: '0', // 默认选中"国家开放大学毕业论文"
    keywords: [],
    literature: [],
    abstract: '', // 摘要
    wordNumber: 6000
  })

// 获取步骤标题的函数
const getStepTitle = (step: number) => {
  const titles = ['基本信息', '文献', '摘要', '大纲'] // 删除了第二步"标题"
  return titles[step] || ''
}

watch(() => form.name, (val) => {
  if(val) validationState.name = true;
});
watch(() => form.region, (val) => {
  if(val) validationState.region = true;
});
watch(() => form.keywords, (val) => {
  if(val && val.length > 0) validationState.keywords = true;
});

watch(form,
(newVal) => {
  console.log(newVal, 'form data')
}, {
  deep: true 
}
);

const back = () => {
  isBackNavigation.value = true
  if (active.value-- < 0) active.value = 3 // 总共4步变成3步
}

const next = () => {
  isBackNavigation.value = false
  if (active.value === 0) {
    validationState.name = !!form.name;
    if (form.name.length > 40) {
      ElMessage.warning('标题不能超过40个字');
      return;
    }
    validationState.region = !!form.region;
    validationState.keywords = !!form.keywords && form.keywords.length > 0;
    if (!validationState.name || !validationState.region || !validationState.keywords) {
      return;
    }
    // 直接跳过第二步，清空文献列表
    form.literature = []
  }
  if (active.value === 1) {
    // 原第三步：验证文献数量必须在8-20条之间
    if (!form.literature || form.literature.length < 8 || form.literature.length > 20) {
      ElMessage({
        message: '请选择8-20篇文献',
        type: 'warning',
      })
      return;
    }
    // 从文献页面前进到摘要页面时，清除摘要缓存以确保重新生成
    form.abstract = ''
  }
  if (active.value === 2) {
    if (!form.abstract) {
      ElMessage({
        message: '请输入摘要内容',
        type: 'warning',
      })
      return;
    }
  }
  if (active.value < 3) { // 原来是4步，现在是3步
    active.value++;
  }
}

const updateCatalogs = (catalogs: any[]) => {
  orderData.catalogs = catalogs;
};

const updateLoading = (loading: boolean) => {
  stepLoading.value = loading;
};

const submit = () => {
  orderData.title = form.name; // 直接使用第一步的标题字段
  orderData.wordNumber = form.wordNumber;
  orderData.orderNumber = '2000' + Date.now();
  orderData.content = ''; // 将content字段设为空字符串
  orderData.keywords = form.keywords;
  orderData.literature = form.literature;
  orderData.abstract = form.abstract;
  // catalogs数据已经通过updateCatalogs函数更新
  confirmDialogVisible.value = true;
}

const showOrderQuery = () => {
  orderQueryVisible.value = true;
}

const showLoginDialog = () => {
  loginDialogVisible.value = true;
}

// 获取用户信息
const fetchUserInfo = async () => {
  try {
    const response = await getUser();
    if (response.data && response.data.code === 0 && response.data.data) {
      const userData = response.data.data;
      // 优先显示userName，如果为空则显示mobile
      userDisplayName.value = userData.userName || userData.mobile || '已登录';
      isLoggedIn.value = true;
    } else if (response.data && response.data.code === -3) {
      // token失效，清除token
      localStorage.removeItem('token');
      userDisplayName.value = '';
      isLoggedIn.value = false;
    }
  } catch (error) {
    console.error('获取用户信息失败:', error);
    // 如果获取失败，清除token
    localStorage.removeItem('token');
    userDisplayName.value = '';
    isLoggedIn.value = false;
  }
}

const handleLoginSuccess = async () => {
  isLoggedIn.value = true;
  loginDialogVisible.value = false; // Close modal on success
  // 登录成功后获取用户信息
  await fetchUserInfo();
}

// 处理下拉菜单命令
const handleCommand = (command: string) => {
  if (command === 'history') {
    showOrderHistory();
  } else if (command === 'logout') {
    handleLogout();
  }
}

// 显示历史订单
const showOrderHistory = () => {
  orderHistoryVisible.value = true;
}

// 从支付弹窗查看累计折扣及权益档位
const showBenefits = () => {
  confirmDialogVisible.value = false;
  orderHistoryVisible.value = true;
}

// 退出登录
const handleLogout = async () => {
  try {
    await ElMessageBox.confirm('确定要退出登录吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    });
    
    try {
      const response = await logout();
      if (response.data && response.data.code === 0) {
        // 清除本地token
        localStorage.removeItem('token');
        isLoggedIn.value = false;
        userDisplayName.value = '';
        ElMessage.success('退出登录成功');
      } else {
        ElMessage.error(response.data?.msg || '退出登录失败');
      }
    } catch (error) {
      // 即使接口调用失败，也清除本地token
      localStorage.removeItem('token');
      isLoggedIn.value = false;
      userDisplayName.value = '';
      ElMessage.warning('已退出登录');
    }
  } catch {
    // 用户取消操作
  }
}

const handlePaymentSuccess = (orderNumber: string) => {
  // 支付成功后，设置订单号并显示订单查询弹窗
  orderQueryOrderNumber.value = orderNumber;
  orderQueryVisible.value = true;
}

const goToHome = () => {
  router.push('/')
}

onMounted(async () => {
  if (localStorage.getItem('token')) {
    // 如果有token，获取用户信息
    await fetchUserInfo();
  }
})

const tipsList = ['填写基本信息，包括标题、类型、关键词和字数预估', '请粘贴或选择相关文献，需要8-20篇', '请确认摘要内容', '请确定好论文大纲（可修改）']


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("view", _hoisted_1, [
    _createElementVNode("view", _hoisted_2, [
      _createElementVNode("span", {
        onClick: goToHome,
        class: "logo-text"
      }, "芝麻开花智能写作平台"),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: showOrderQuery,
          class: "order-download-btn",
          type: "primary",
          size: "default",
          plain: ""
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode("订单下载")
          ])),
          _: 1
        }),
        (!isLoggedIn.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: showLoginDialog,
              class: "login-btn",
              type: "primary",
              size: "default"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("登录")
              ])),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_el_dropdown, {
              key: 1,
              onCommand: handleCommand,
              trigger: "hover",
              class: "user-dropdown"
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, { command: "history" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Document))
                          ]),
                          _: 1
                        }),
                        _cache[6] || (_cache[6] = _createElementVNode("span", null, "权益信息", -1))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, {
                      command: "logout",
                      divided: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(SwitchButton))
                          ]),
                          _: 1
                        }),
                        _cache[7] || (_cache[7] = _createElementVNode("span", null, "退出登录", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_el_avatar, {
                    size: 32,
                    class: "user-avatar"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(User))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(userDisplayName.value), 1),
                  _createVNode(_component_el_icon, { class: "dropdown-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowDown))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }))
      ])
    ]),
    _createElementVNode("view", _hoisted_6, [
      _createElementVNode("view", _hoisted_7, [
        _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "mb-[20px] mt-[10px] text-[14px] lg:text-base text-center lg:text-left" }, "根据需求自动完成论文写作", -1)),
        _createElementVNode("view", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, "步骤 " + _toDisplayString(active.value + 1) + " / 4", 1),
              _createElementVNode("div", _hoisted_12, _toDisplayString(getStepTitle(active.value)), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", {
                class: "bg-blue-600 h-2 rounded-full transition-all duration-300",
                style: _normalizeStyle({width: `${(active.value + 1) * 25}%`})
              }, null, 4)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_steps, {
              active: active.value,
              "finish-status": "success"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_step, { title: "基本信息" }),
                _createVNode(_component_el_step, { title: "文献" }),
                _createVNode(_component_el_step, { title: "摘要" }),
                _createVNode(_component_el_step, { title: "大纲" })
              ]),
              _: 1
            }, 8, ["active"])
          ]),
          _createElementVNode("view", _hoisted_15, _toDisplayString(tipsList[active.value]), 1),
          _createVNode(_component_el_form, {
            model: form,
            "label-width": "100px",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              (active.value === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(FirstStep, {
                      form: form,
                      "validation-state": validationState
                    }, null, 8, ["form", "validation-state"])
                  ]))
                : _createCommentVNode("", true),
              (active.value === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(ThreeStep, { form: form }, null, 8, ["form"])
                  ]))
                : _createCommentVNode("", true),
              (active.value === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(FourStep, {
                      form: form,
                      "is-back-navigation": isBackNavigation.value
                    }, null, 8, ["form", "is-back-navigation"])
                  ]))
                : _createCommentVNode("", true),
              (active.value === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(FiveStep, {
                      form: form,
                      "onUpdate:catalogs": updateCatalogs,
                      "onUpdate:loading": updateLoading
                    }, null, 8, ["form"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["model"]),
          (active.value < 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  (active.value > 0)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: back,
                        size: "default",
                        class: "mobile-button",
                        type: "default"
                      }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("上一步")
                        ])),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    onClick: next,
                    size: "default",
                    class: "mobile-button",
                    type: "primary"
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("下一步")
                    ])),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (active.value === 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_el_button, {
                    onClick: back,
                    size: "default",
                    class: "mobile-button",
                    type: "default",
                    disabled: stepLoading.value
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("上一步")
                    ])),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_el_button, {
                    onClick: submit,
                    size: "default",
                    class: "mobile-button",
                    type: "success",
                    disabled: stepLoading.value,
                    loading: stepLoading.value
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("提交")
                    ])),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(ConfirmOrder, {
      visible: confirmDialogVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (confirmDialogVisible.value = $event)),
      onPaymentSuccess: handlePaymentSuccess,
      onShowBenefits: showBenefits,
      order: orderData,
      "is-logged-in": isLoggedIn.value,
      "on-show-login": showLoginDialog
    }, null, 8, ["visible", "order", "is-logged-in"]),
    _createVNode(OrderQuery, {
      visible: orderQueryVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (orderQueryVisible.value = $event)),
      "preset-order-number": orderQueryOrderNumber.value
    }, null, 8, ["visible", "preset-order-number"]),
    _createVNode(LoginModal, {
      visible: loginDialogVisible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (loginDialogVisible.value = $event)),
      onLoginSuccess: handleLoginSuccess
    }, null, 8, ["visible"]),
    _createVNode(OrderHistory, {
      visible: orderHistoryVisible.value,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (orderHistoryVisible.value = $event))
    }, null, 8, ["visible"])
  ]))
}
}

})